import Echo from "laravel-echo";
import Pusher from "pusher-js";

declare global {
	interface Window {
		Pusher: typeof Pusher;
	}
}

let echo: Echo<"reverb"> | undefined;

export function getRealtimeEcho(): Echo<"reverb"> | undefined {
	if (typeof window === "undefined") {
		return undefined;
	}
	if (echo) {
		return echo;
	}

	window.Pusher = Pusher;
	const forceTLS =
		(import.meta.env.VITE_REVERB_SCHEME ?? window.location.protocol.slice(0, -1)) ===
		"https";
	const configuredPort = Number(import.meta.env.VITE_REVERB_PORT);

	echo = new Echo<"reverb">({
		broadcaster: "reverb",
		key: import.meta.env.VITE_REVERB_APP_KEY ?? "gvtlabs-frontend",
		wsHost: import.meta.env.VITE_REVERB_HOST ?? window.location.hostname,
		wsPort: Number.isFinite(configuredPort) ? configuredPort : 80,
		wssPort: Number.isFinite(configuredPort) ? configuredPort : 443,
		forceTLS,
		enabledTransports: ["ws", "wss"],
		authEndpoint: `${window.location.origin}/broadcasting/auth`,
		auth: {
			headers: {
				"X-CSRF-TOKEN":
					document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
						?.content ?? "",
			},
		},
	});

	return echo;
}
